module.exports = __webpack_public_path__ + "static/ourne.f0719141.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/ourne.webp
// module id = 912
// module chunks = 3